import { render } from "./WhyChoseUs.vue?vue&type=template&id=a68bf570&scoped=true"
import script from "./WhyChoseUs.vue?vue&type=script&lang=js"
export * from "./WhyChoseUs.vue?vue&type=script&lang=js"

import "./WhyChoseUs.vue?vue&type=style&index=0&id=a68bf570&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a68bf570"]])

export default __exports__